import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'ui-typeahead',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiTypeaheadComponent),
      multi: true,
    },
  ],
  template: `
    <input
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      [ngbTypeahead]="search"
      [resultTemplate]="resultTpl"
      [(ngModel)]="model"
      (selectItem)="selectItem.emit($event.item)"
    />

    <ng-template let-r="result" let-t="term" #resultTpl>
      <ngb-highlight [result]="r" [term]="t"></ngb-highlight>
    </ng-template>
  `,
})
export class UiTypeaheadComponent implements ControlValueAccessor {
  @Input() model = '';
  @Input() placeholder = '';
  @Input() search: (text: Observable<string>) => Observable<any[]>;

  @Output() selectItem = new EventEmitter<any>();

  writeValue(value: any): void {
    this.model = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange(value: any): void {}

  onTouched(): void {}
}
